import { closeModalHelper, openModalHelper } from '../../js/helpers/modals'

export default () => {
  let $ = jQuery

  $('#slider-range-1').slider({
    range: true,
    min: 50000,
    max: 15000000,
    step: 25000,
    values: [50000, 15000000],
    animate: 'fast',
    slide: function (event, ui) {
      $('#reserveAmount').val(
        '$' +
          ui.values[0].toLocaleString() +
          ' to $' +
          ui.values[1].toLocaleString()
      )
    },
  })
  $('#reserveAmount').val(
    '$' +
      $('#slider-range-1').slider('values', 0).toLocaleString() +
      ' to $' +
      $('#slider-range-1').slider('values', 1).toLocaleString()
  )

  const steps = Array.from(document.querySelectorAll('.form-cta__step'))
  let formCategory = $('.form-cta-wrap .form-cta.form-cta-popup').data(
    'category'
  )

  const mainModal = document.querySelector('.form-cta')
  const modalWrap = document.querySelector('.form-cta-wrap')

  const thankYouModal = document.querySelector('.form-cta-thank')
  const errorModal = document.querySelector('.form-cta-error')

  const modalClose = Array.from(document.querySelectorAll('.form-cta__close'))
  const modalHandlers = Array.from(
    document.querySelectorAll('.form-cta-handler')
  )

  const pageCta = Array.from(document.querySelectorAll('.form-page-cta'))

  const loader = document.querySelector('.form-cta-loader')

  let formData = []
  let stepId = 1

  const openStep = (id) => {
    steps.forEach((step) => {
      step.classList.remove('active')
    })
    const stepCurrent = document.querySelector(
      `.form-cta__step[data-step="${id}"]`
    )
    stepCurrent.classList.add('active')
  }

  const toggleElement = (el) => {
    el.classList.toggle('opened')
  }

  const sendForm = (silent = false) => {
    if (!silent) toggleElement(mainModal)

    stepId = 1

    $.ajax({
      url: window.ajax_.ajax_url,
      type: 'POST',
      data: {
        action: 'sendFormCta',
        category: formCategory,
        data: formData,
      },
      beforeSend: () => {
        if (!silent) toggleElement(loader)
      },
      success: response => {
        if (!silent) {
          toggleElement(loader)
          if (response.success) {
            toggleElement(thankYouModal)
          } else {
            console.log(response)
            toggleElement(errorModal)
          }
        }
      },
      error: error => {
        if (!silent) {
          console.log(error)
          toggleElement(loader)
          toggleElement(errorModal)
        }
      },
    })
  }

  modalHandlers.forEach((modalHandler) => {
    modalHandler.addEventListener('click', (event) => {
      event.preventDefault()
      modalWrap.classList.add('opened')
      toggleElement(mainModal)
      openStep(1)
      openModalHelper()
    })
  })

  modalClose.forEach(function (modalCloseEl) {
    modalCloseEl.addEventListener('click', () => {
      modalWrap.classList.remove('opened')
      const parent = modalCloseEl.closest('.form-cta-popup')
      toggleElement(parent)
      stepId = 1
      formData = []
      document.body.classList.remove('js-no-scroll')
      closeModalHelper()
    })
  })

  // collecting data from steps
  steps.forEach((step, stepId) => {
    step.addEventListener('submit', function (event) {
      event.preventDefault()

      $('form[data-step="1"]').validate({
        rules: {
          first_name: {
            required: true,
            maxlength: 50,
            minlength: 1,
          },
          last_name: {
            required: true,
            maxlength: 50,
            minlength: 1,
          },
          phone: {
            required: true,
            number: true,
          },
          email: {
            required: true,
            email: true,
            maxlength: 50,
            minlength: 1,
          },
        },
        messages: {
          first_name: {
            required: 'Please specify your fisrt name',
          },
          last_name: {
            required: 'Please specify your last name',
          },
          phone: {
            required: 'Please provide a phone number',
            number: 'Please enter a valid number (without +)',
          },
          email: {
            required: 'Please enter your email',
            email: 'Please enter a valid email address',
          },
        },
      })

      if (stepId == 2 && checkForErrors(step)) return

      if ($('form[data-step="1"]').valid()) {
        const stepData = $(step).serializeArray()
        stepData.forEach((obj) => {
          obj.meaning = document
            .querySelector(`.js-collect-data[name="${obj.name}"]`)
            .getAttribute('data-name')
        })

        formData.push(...stepData)

        stepId = +step.getAttribute('data-step') + 1
        if (stepId < 6) openStep(stepId)
        // if (stepId == 6) sendForm()
      }
    })
  })

  // closing modal on clicking outside the modal
  modalWrap.addEventListener('click', function (event) {
    if (
      !event.target.classList.contains('.form-cta-popup') &&
      !event.target.closest('.form-cta-popup')
    ) {
      stepId = 1
      formData = []
      modalWrap.classList.remove('opened')
      mainModal.classList.remove('opened')
      errorModal.classList.remove('opened')
      thankYouModal.classList.remove('opened')
      document.body.classList.remove('js-no-scroll')
      closeModalHelper()
    }
  })

  // writing address from page cta form to modal
  pageCta.forEach((form) => {
    const btn = form.querySelector('.form-page-cta__submit')
    btn.addEventListener('click', function () {
      const address = form.querySelector('input').value
      const popupInput = document.querySelector(
        '.form-cta-popup input[name="address"]'
      )
      popupInput.value = address
    })
  })

  // validation
  function checkForErrors(form) {
    const inputReserve = form.querySelector('input[name="reserveAmount"]')
    const inputCheckbox = form.querySelector('input[name="valuationFeedback"]')
    if (!inputReserve || !inputCheckbox) return

    const formError = form.querySelector('.form-error')
    let errors
    if (inputReserve.value == '' && !inputCheckbox.checked) {
      errors = true
      formError.style.display = 'block'
    } else if (inputReserve.value || inputCheckbox.checked) {
      errors = false
      formError.style.display = 'none'
    }
    return errors
  }

  const formatNumber = document.querySelectorAll('.format-number')
  if (formatNumber.length) {
    Array.from(formatNumber).forEach(function (input) {
      input.addEventListener('input', function () {
        input.value = input.value.replace(/[^0-9\.+]+/g, '')
      })
    })
  }

  const inputEmail = document.querySelector('input[type="email"]')
  const inputEmailError = document.querySelector(
    'input[type="email"] + .form-error'
  )
  if (inputEmailError) inputEmailError.style.display = 'none'

  inputEmail.addEventListener('keyup', function () {
    if (!validateEmail(inputEmail.value)) {
      inputEmailError.style.display = 'block'
    } else {
      inputEmailError.style.display = 'none'
    }
  })

  function validateEmail(email) {
    var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return re.test(email)
  }

  const openSellerModal = document.querySelector('.js-create-seller-account')
  if (openSellerModal) {
    const buyerModal = document.querySelector('.form-status-wrap')

    openSellerModal.addEventListener('click', () => {
      sendForm(true)

      const prefilledEmail = $('.form-cta__step input[type="email"]').val()
      localStorage.setItem('role', 'Seller')
      $('.form-cta-wrap').removeClass('opened')
      $('.form-cta-popup').removeClass('opened')
      $('.js-sign-in-form').removeClass('active')

      buyerModal.querySelector('.form-profile__step-text').style.display = 'none'
      buyerModal.querySelector('.form-profile__step[data-step="1"]').classList.remove('active')
      buyerModal.querySelector('.form-profile__step[data-step="create-account"]').classList.add('active')
      buyerModal.querySelector('.form-profile__step[data-step="create-account"] input[type="email"]').value = prefilledEmail

      if ($(openSellerModal).data('from-offers-modal')) {
        let phone = $('.form-cta__step input[name="phone"]').val()
        let firstName = $('.form-cta__step input[name="first_name"]').val()
        let lastName = $('.form-cta__step input[name="last_name"]').val()

        let prefilledFields = `<input type="hidden" name="first_name" value="${firstName}">`
        prefilledFields += `<input type="hidden" name="last_name" value="${lastName}">`
        prefilledFields += `<input type="hidden" name="phone" value="${phone}">`
        $('.form-profile__sub-step.active').append(prefilledFields)
      }

      buyerModal.classList.add('opened')
      buyerModal.querySelector('.form-profile').classList.add('opened')
    })
  }

  const closeModalLastStep = document.querySelector('.js-close-cta-modal')

  closeModalLastStep.addEventListener('click', function (event) {
    sendForm()
  })

  if (closeModalLastStep) {
    //sendForm()
  }
}
